import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FBF7F1] text-[#1A1A1A] py-12 px-5 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" data-testid="terms-back"
          className="text-xs text-[#9A9A9A] hover:text-[#1A1A1A] inline-flex items-center gap-1 mb-6">
          <ArrowLeft className="h-3 w-3" /> Torna alla home
        </Link>
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#9A9A9A] mb-2">Documento legale</div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight">Termini di Servizio</h1>
        <p className="text-xs text-[#9A9A9A] mt-2">Ultimo aggiornamento: febbraio 2026</p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-[#1A1A1A]">
          <Section title="1. Oggetto del servizio">
            ORIO è un&apos;infrastruttura digitale per la gestione della vita del cane:
            passaporto digitale, emergenze geolocalizzate, missioni di soccorso, organizzazione di passeggiate,
            archivio documenti e sistema di prevenzione anti-fuga.
            ORIO <strong>non</strong> vende hardware (collari, GPS) e <strong>non sostituisce</strong> il microchip,
            il libretto sanitario cartaceo, né le autorità competenti.
          </Section>

          <Section title="2. Account">
            Per usare ORIO devi avere almeno 18 anni e fornire dati veritieri. Sei responsabile della
            riservatezza delle tue credenziali. Notifica subito a noi qualsiasi uso non autorizzato.
          </Section>

          <Section title="3. Piano gratuito e Piano Pro">
            Il piano gratuito permette di registrarti, gestire 1 cane, vedere la mappa e consultare le missioni.
            Il piano Pro (4,99 €/mese, 30 giorni di prova gratuita una sola volta) sblocca:
            pulsante Emergenza SOS, creazione e partecipazione a missioni, Match, Cassetto digitale,
            Diario con disegno, Sistema di Prevenzione anti-fuga, cani illimitati e Karma.
          </Section>

          <Section title="4. Disdetta">
            Puoi disdire l&apos;abbonamento in qualsiasi momento dall&apos;area Profilo: il pagamento già effettuato
            resta valido fino alla scadenza, dopo di che tornerai al piano gratuito.
            Nessuna penale e nessun vincolo di durata.
          </Section>

          <Section title="5. Uso accettabile">
            È vietato: pubblicare emergenze false, chiudere missioni non realmente risolte per ottenere Karma,
            molestare altri utenti, usare il sistema per attività illegali. Violazioni comportano sospensione
            o cancellazione dell&apos;account.
          </Section>

          <Section title="6. Responsabilità">
            ORIO è uno strumento di coordinamento e prevenzione: la decisione finale e l&apos;intervento concreto
            spettano sempre alle persone fisiche coinvolte e, dove necessario, alle autorità competenti
            (Polizia, Veterinari, ASL, Forze dell&apos;ordine). ORIO non garantisce il ritrovamento del cane
            né la risoluzione di una missione.
          </Section>

          <Section title="7. Geolocalizzazione e prevenzione anti-fuga">
            Il sistema di prevenzione anti-fuga funziona quando l&apos;app è aperta sullo smartphone e con
            permessi di geolocalizzazione attivi. Su iOS la tracciatura in background è limitata dal sistema
            operativo. ORIO non garantisce il funzionamento in tutti i contesti — è uno strumento di supporto,
            non un sostituto della tua attenzione personale.
          </Section>

          <Section title="8. Proprietà intellettuale">
            Marchio, design e codice sono di proprietà di ORIO. I contenuti che pubblichi (foto del cane,
            documenti, note) restano di tua proprietà; ci concedi solo la licenza per erogarti il servizio.
          </Section>

          <Section title="9. Modifiche">
            Possiamo aggiornare questi termini con notifica via email o in-app con almeno 30 giorni di preavviso.
          </Section>

          <Section title="10. Foro competente">
            Foro di residenza del consumatore secondo la normativa italiana ed europea applicabile.
          </Section>

          <p className="pt-6 text-xs text-[#9A9A9A]">
            Per qualsiasi domanda: <a className="underline" href="mailto:legal@orio.app">legal@orio.app</a>
          </p>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl mb-2 text-[#1A1A1A]">{title}</h2>
      <div>{children}</div>
    </div>
  );
}
